export default __webpack_public_path__ + "images/256x145.2f3138556f7407b509cff2892b8cb71d.jpg";